/* The SentryException class provides a method to filter Sentry exceptions based on specific criteria. */
import { Event } from '@sentry/core';
export class SentryException {
  public filterSentryException(event: Event): boolean {
    const pattern = /scriptInject/i;
    const getException =
      event &&
      event.exception &&
      event.exception.values &&
      event.exception.values.length > 0 &&
      event.exception.values[0] &&
      event.exception.values[0].stacktrace &&
      event.exception.values[0].stacktrace.frames &&
      event.exception.values[0].stacktrace.frames.length > 0
        ? event.exception.values[0].stacktrace.frames.map(
            frame => frame.function
          )
        : [];
    // Restrict sentry logging Http Failure response
    const unknownErr =
      event && event.message && event.message.includes('ReleaseSeatFromCart');

    // Filter expected 400 "Website not found" on bare root '/' or '/error-page' (MP-5600 / SMTX-V3-ANGULAR-9AK)
    const isWebsiteNotFound =
      Boolean(event?.message && event.message.includes('Website not found')) ||
      Boolean(
        event?.exception?.values &&
          event.exception.values.some(v => v.value && v.value.includes('Website not found'))
      );
    const isBareRootOrErrorPage =
      typeof window !== 'undefined' &&
      Boolean(
        window.location &&
          (window.location.pathname === '/' ||
            window.location.pathname === '/error-page' ||
            window.location.pathname === '')
      );
    const isBareRootWebsiteNotFound = isWebsiteNotFound && isBareRootOrErrorPage;

    if (
      (getException &&
        getException.length > 0 &&
        getException.some(r => pattern.test(r))) ||
      unknownErr ||
      isBareRootWebsiteNotFound
    )
      return true;
    else return false;
  }
}
